import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/* Gedeelde logo-URL (blob) met invalidatie na upload/verwijderen */
let _cache = null;
const _listeners = new Set();

export function invalidateLogo() {
  if (_cache) URL.revokeObjectURL(_cache);
  _cache = null;
  _listeners.forEach((l) => l());
}

export function useLogoUrl() {
  const [url, setUrl] = useState(_cache);

  useEffect(() => {
    let actief = true;
    const laad = async () => {
      if (_cache) { setUrl(_cache); return; }
      try {
        const res = await api.get("/templates/logo", { responseType: "blob" });
        _cache = URL.createObjectURL(res.data);
        if (actief) setUrl(_cache);
      } catch { if (actief) setUrl(null); }
    };
    laad();
    const listener = () => { setUrl(null); laad(); };
    _listeners.add(listener);
    return () => { actief = false; _listeners.delete(listener); };
  }, []);

  return url;
}
